import { render, staticRenderFns } from "./brandManageList.vue?vue&type=template&id=b2425a04&scoped=true"
import script from "./brandManageList.vue?vue&type=script&lang=js"
export * from "./brandManageList.vue?vue&type=script&lang=js"
import style0 from "./brandManageList.vue?vue&type=style&index=0&id=b2425a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2425a04",
  null
  
)

export default component.exports